export default function PlatformHeader() {
  return (
    <header className="site-header" id="top">
      <div className="container nav-wrap">
        <a className="brand" href="#top" aria-label="OneStack home">
          <span className="brand-mark">{"O"}</span>
          <span className="brand-text">{"OneStack"}</span>
        </a>

        <button className="mobile-menu-btn" id="mobileMenuBtn" aria-label="Open menu" aria-expanded="false">
          <span></span><span></span><span></span>
        </button>

        <nav className="main-nav" id="mainNav" aria-label="Primary navigation">
          <a href="#platform">{"Platform"}</a>
          <a href="#technology">{"Technology"}</a>
          <a href="#payments">{"Payments"}</a>
          <a href="#experience">{"Customer Experience"}</a>
          <a href="#apps">{"Business Apps"}</a>
          <a href="#solutions">{"Solutions"}</a>
          <a href="#pricing">{"Pricing"}</a>
          <a href="#resources">{"Resources"}</a>
        </nav>

        <div className="nav-actions">
          <a className="text-link" href="#contact">{"Sign In"}</a>
          <a className="btn btn-ghost" href="#contact">{"Talk to an Expert"}</a>
          <a className="btn btn-primary" href="#pricing">{"Start Free"}</a>
        </div>
      </div>
    </header>
  );
}
